import { lettersWithSpaceRegex } from 'constants/regex'
import { isStringArray } from 'utils/helpers/array'
import { GOOGLE_MAP_CITY_NAMES, GOOGLE_MAP_COUNTRY_NAMES } from './constants'

const prepareValue = (value?: string) =>
  value && lettersWithSpaceRegex.test(value) ? value : ''

export const getAddressComponents = (
  place: google.maps.places.PlaceResult,
  selectedCountry: string,
  selectedCity: string
) => {
  if (!place.address_components || !place.geometry) return null

  const components = place.address_components

  const building = components.find((component) =>
    component.types.includes('street_number')
  )?.long_name

  const street = components.find((component) =>
    component.types.includes('route')
  )?.long_name

  let country = ''
  const currentCountry = components.find((component) =>
    component.types.includes('country')
  )?.long_name

  if (currentCountry) {
    const countryValue = GOOGLE_MAP_COUNTRY_NAMES[currentCountry]

    if (isStringArray(countryValue)) {
      country = countryValue.includes(selectedCountry)
        ? selectedCountry
        : currentCountry
    } else {
      country = countryValue || currentCountry
    }
  }

  let city = ''

  const currentCity =
    components.find((component) => component.types.includes('locality'))
      ?.long_name ||
    components.find((component) => component.types.includes('postal_town'))
      ?.long_name ||
    components.find((component) =>
      component.types.includes('administrative_area_level_3')
    )?.long_name ||
    components.find((component) =>
      component.types.includes('administrative_area_level_2')
    )?.long_name ||
    ''

  if (currentCity) {
    const cityValue = GOOGLE_MAP_CITY_NAMES[currentCity]

    if (isStringArray(cityValue)) {
      city = cityValue.includes(selectedCity) ? selectedCity : currentCity
    } else {
      city = cityValue || currentCity
    }

    city =
      city.toLowerCase() === selectedCity.toLowerCase() ? selectedCity : city
  }

  const state =
    components.find((component) =>
      component.types.includes('administrative_area_level_1')
    )?.long_name || ''

  const postalCode = components.find((c) =>
    c.types.includes('postal_code')
  )?.long_name

  const lat = place.geometry.location?.lat()
  const lng = place.geometry.location?.lng()

  return {
    state: state,
    street: prepareValue(street),
    building: building || '',
    city: city,
    postalCode: postalCode || '',
    lat: lat || null,
    lng: lng || null,
    country: country,
  }
}
